import { render, staticRenderFns } from "./BaseChip.vue?vue&type=template&id=41fdb30a&scoped=true"
import script from "./BaseChip.vue?vue&type=script&lang=js"
export * from "./BaseChip.vue?vue&type=script&lang=js"
import style0 from "./BaseChip.vue?vue&type=style&index=0&id=41fdb30a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41fdb30a",
  null
  
)

export default component.exports